import React, { FC } from 'react'
import { Box, BoxProps } from '@gassan-ui'
import { Heading, Text } from '@rolex-ui'
import { rem } from 'polished'

type Props = BoxProps & {
  preTitle?: string
  title?: string
  description?: string
}

const TextBlock: FC<Props> = ({ preTitle, title, description, children, ...rest }) => {
  return (
    <Box
      as="section"
      {...rest}
      px="20px"
      textAlign="center"
      mx="auto"
      maxWidth={rem(680)}
      mb={rem(20)}
    >
      {preTitle && (
        <Heading variant="verySmallTitle" as="h2" color="shades.700" mb="1.25rem">
          {preTitle}
        </Heading>
      )}
      {title && (
        <Heading variant="largeTitle" as="h1" mb="1.25rem">
          {title}
        </Heading>
      )}
      {description && (
        <Text size="regular" maxWidth="870px" mx="auto" mb="0">
          {description}
        </Text>
      )}
      {children}
    </Box>
  )
}

export default TextBlock
